import type { CssGeneratorContext } from '../css-generator.model';

/** AppBanner — blue-tinted leading icon + text row. */
export const styles = ({ dt }: CssGeneratorContext) => `
app-banner .app-banner-root {
  display: flex;
  align-items: ${dt('appBanner.alignItems')} !important;
  padding-left: ${dt('appBanner.paddingLeft')} !important;
  gap: ${dt('appBanner.gap')} !important;
}

app-banner .app-banner-root > i.pi {
  flex-shrink: 0;
  color: ${dt('appBanner.icon.color')} !important;
  font-size: ${dt('appBanner.icon.fontSize')};
}

app-banner .app-banner-text {
  margin: 0;
  font-size: ${dt('appBanner.text.fontSize')} !important;
  line-height: ${dt('appBanner.text.lineHeight')} !important;
  color: ${dt('appBanner.text.color')} !important;
  flex: 1;
}

/* Card variant — icon column on the left, title + description stacked on the
   right with the description aligned under the title (not under the icon). */
app-banner .app-banner-root.app-banner-card {
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: ${dt('appBanner.card.bodyGap')};
}

app-banner .app-banner-card > i.pi {
  grid-column: 1;
  grid-row: 1 / -1;
  align-self: center;
}

app-banner .app-banner-card .app-banner-title {
  margin: 0;
  grid-column: 2;
  grid-row: 1;
  font-size: ${dt('appBanner.card.title.fontSize')};
  line-height: ${dt('appBanner.card.title.lineHeight')};
  font-weight: ${dt('appBanner.card.title.fontWeight')};
  color: ${dt('appBanner.card.title.color')};
}

app-banner .app-banner-card .app-banner-text {
  grid-column: 2;
  grid-row: 2;
}
`;
